<template>
    <div class="bundle-or-promo-tag-and-button">
        <div :class="['bundle-or-promo-name-and-price', tagColor]">
            <div class="text-part-style">
                <span class="text-style">
                    {{ name }}
                </span>
            </div>
            <div class="price-part-style">
                <span class="price-style flex">
                    <span>$ </span>
                    <span>
                        {{ price.toFixed(2) }}
                    </span>
                </span>
            </div>
        </div>
        <el-button :class="['choose-button', buttonColor]" @click="handleButtonClick">{{ chooseBundleOrPromo }}</el-button>
    </div>
</template>

<script>
export default {
    name: "BundleOrPromoTagAndButton",
    props: {
        name: {
            type: String,
            default: "",
        },
        price: {
            type: Number,
            default: 0,
        },
        chooseBundleOrPromo: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "lower",
        },  
    },

    computed: {
        buttonColor() {
            return this.type === "lower" ? "lower-price-button-color" : "higher-price-button-color";
        },
        tagColor() {
            return this.type === "lower" ? "lower-price-tag-color" : "higher-price-tag-color";
        },
    },
    methods: {
        handleButtonClick() {
            this.$emit('buttonClick')
        }
    }
}
</script>

<style scoped>
.lower-price-tag-color{
    color: #20A7C1;
}

.higher-price-tag-color{
    color: #161616;
}

.lower-price-button-color{
    background-color: #20A7C1 !important;
    color: #FFF !important;
}

.lower-price-button-color:hover{
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), var(--color-Cyan-000, #20A7C1);
    color: #FFF;
}

.lower-price-button-color:active{
    border-radius: var(--radius, 4px);
    border: 1px solid rgba(0, 0, 0, 0.15);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), var(--color-Cyan-000, #20A7C1);
}

.higher-price-button-color{
    background-color: #FFF !important;
    color: #20A7C1 !important;
    border: 1px solid #20A7C1 !important;
}

.higher-price-button-color:hover{
    background: rgba(32, 167, 193, 0.10) !important;
    color: #20A7C1 !important;
    border: 1px solid #20A7C1 !important;
}

.higher-price-button-color:active{
    background: rgba(32, 167, 193, 0.10) !important;
    color: #20A7C1 !important;
    border: 2px solid var(--color-Cyan-000, #20A7C1) !important;
}

.bundle-or-promo-tag-and-button {
    display: flex;
    width: 217px;
    height: 195px;
    padding: 10px 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    flex-shrink: 0;
    border-radius: 4px;
    background: #FFF;
}

.bundle-or-promo-name-and-price {
    width: 177px;
    height: 89px;
    /* border-radius: 4px; */
}

.text-part-style {
    height: 36px;
    display: flex;
    padding: 10px 0px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border-top: 1px solid var(--color-Grey-Grey-E6, #E6E6E6);
    border-right: 1px solid var(--color-Grey-Grey-E6, #E6E6E6);
    border-left: 1px solid var(--color-Grey-Grey-E6, #E6E6E6);
    background: #EEF5FC;
    border-radius: 4px 4px 0px 0px;
}

.price-part-style {
    height: 53px;
    display: flex;
    padding: 15px 4px;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    border-right: 1px solid var(--color-Grey-Grey-E6, #E6E6E6);
    border-bottom: 1px solid var(--color-Grey-Grey-E6, #E6E6E6);
    border-left: 1px solid var(--color-Grey-Grey-E6, #E6E6E6);
    background: #FFF;
    border-radius: 0px 0px 4px 4px;
}

.text-style{
    width: 166.333px;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.price-style {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    flex: 1 0 0;
    text-align: center;
    text-overflow: ellipsis;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;    
}

.choose-button {
    display: flex;
    height: 42px;
    padding: var(--V-padding, 16px) var(--H-padding, 24px);
    justify-content: center;
    align-items: center;
    gap: var(--Spacing, 12px);
    flex-shrink: 0;
    align-self: stretch;
    border-radius: var(--radius, 4px);
}
</style>
